import { getNpc, getQuest } from '@jianghu/game-data';
import { useGame } from '../../game/store';
import { useGameInstance } from './GameContext';

export function QuestTracker() {
  const game = useGameInstance();
  const quests = useGame((s) => s.quests).filter((q) => q.status === 'active');
  if (quests.length === 0) return null;
  return (
    <aside className="quest-tracker" aria-label="Quest tracker">
      {quests.map((q) => {
        const def = getQuest(q.id);
        return (
          <div key={q.id} className="q">
            <h4>
              <button
                className="quest-link"
                title="Auto-travel to the next objective"
                onClick={() => game?.travelToQuest(q.id)}
              >
                {def?.name ?? q.id} <span aria-hidden="true">➜</span>
              </button>
            </h4>
            {q.ready ? (
              <div className="ready">✦ Return to {def ? npcName(def.turnInNpcId) : 'the quest giver'}</div>
            ) : (
              q.objectives.map((o) => (
                <div key={o.id} className={`obj ${o.current >= o.required ? 'done' : ''}`}>
                  {o.current >= o.required ? '✓ ' : '· '}
                  {o.label}
                  {o.required > 1 ? ` ${o.current}/${o.required}` : ''}
                </div>
              ))
            )}
          </div>
        );
      })}
    </aside>
  );
}

export function npcName(id: string): string {
  const n = getNpc(id);
  return n ? `${n.title} ${n.name}` : id;
}
